<template>
    <div class="form-page" v-if="formsData != null">
        <div class="container">
            <div class="form-container">
                <div class="form-titles" :class="{'hide' : !formVisible}">
                    <h3>{{formsData.page_form_title}}</h3>
                    <span>{{formsData.page_form_title_desc}}</span>
                </div>
                <form class="form_call" v-if="formVisible">
                    <div class="form-in" :class="{fadeOut : !formVisible}">
                        <div class="form-group form-text" :class="{'error' : errors.has('name')}">
                            <label for="name">{{ formsData.label_name }}</label>
                            <input type="text" name="name" class="form-control" :placeholder="formsData.inputname" v-model="name" v-validate="{ required: true, regex: regexRules.name }"  data-vv-delay="1000">
                        </div>
                        <div class="form-group form-phone" :class="{'error' : errors.has('phone')}">
                            <label for="phone">{{ formsData.label_phone }}</label>
                            <masked-input v-model="phone" mask="\+\7 (111) 111-11-11" placeholder="+7" class="form-control" name="phone" v-validate="{ required: true, regex: regexRules.phone }" data-vv-delay="1000"/>
                        </div>
                        <div class="btn-send">
                            <button class="btn btn-submit btn-success" type="button" @click="sendData" :disabled="errors.any()">
                                <span>{{formsData.btn_name}}</span>
                                <svgIcon name="arrow-right" class="icon-right-arrow"/>
                            </button>
                            <!-- <span class="error-message" v-show="errors.has('name') || errors.has('phone')">Заполните все поля</span> -->
                        </div>
                    </div>
                </form>
                <div class="successMessage-formpage" v-if="!formVisible">
                    <h3>Спасибо! Ваша заявка отправлена.</h3>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import MaskedInput from 'vue-masked-input'
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'FormConsultLand',
        data () {
            return {
                pageID: this.$route.name,
                phone: '',
                name: '',
                admin_mail: '',
                agree: false,
                formVisible: true,
                errorMsg: false,
                regexRules: {
                    name: /^([а-яА-ЯёЁa-zA-Z].*[\s\.]*){3,35}$/,
                    phone: /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{10,10}$/,
                }
            }
        },
        components: {
            MaskedInput,
            svgIcon,
        },
        computed: mapGetters({
            formsData: 'loadFormsData',
        }),
        methods: {
            sendData() {
                var querystring = require('querystring');
                var urlForm = window.mainUrl + '/server/form-consult.php';
                var dataForm = {
                    'admin': this.formsData.admin_email,
                    'name': this.name,
                    'phone': this.phone,
                    'pageID': this.pageID,
                };
                this.$validator.validate().then(result => {
                    if(result) {
                        this.formVisible = false;
                        axios.post(urlForm, querystring.stringify(dataForm));
                        $.ajax({
                            url: "https://docs.google.com/forms/d/e/1FAIpQLSdrFyivRlfu0xnzZoL2LI1X71wOy0rJyQUDKYWT3Gq--H31eQ/formResponse",
                            data: {
                                "entry.1150638632" : dataForm.name,
                                "entry.1611339641" : dataForm.phone,
                                "entry.1705610405" : dataForm.pageID,
                            },
                            type: "GET",
                            dataType: "xml"
                        });
                    } else {
                        this.errorMsg = true;
                        console.log('Form inputs with errors');
                    }
                });
            },
        },
        beforeCreate() {
            // this.$store.dispatch('getFormsData');
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-page.scss';
    @import '@/styles/components/forms/respond/form-page-respond.scss';
    // @import '@/styles/respond/forms/form-page-respond.scss';
    // @import '@/styles/components/forms/forms-respond/form-sales-land-respond.scss';
    // @import '@/styles/respond/forms/form-sales-land-respond.scss';
    // @import '@/styles/respond/forms/form-consult-respond.scss';
</style>